import { Address, Client, ClientLocation } from '@core/models';
import { createAction, props } from '@ngrx/store';

export const CLIENT_FIND = createAction('[Client] Find');
export const CLIENT_FIND_SUCCESS = createAction('[Client] Find Success', props<{ client: Client }>());
export const CLIENT_FAILED = createAction('[Client] Failed', props<{ error: string }>());
export const CLIENT_UPDATE_LOADING = createAction('[Client] Update Loading', props<{ loading: boolean }>());
export const CLIENT_REMOVE_ADDRESS = createAction('[Client] Remove Address', props<{ idAddress: string }>());
export const CLIENT_CREATE_ADDRESS = createAction('[Client] Create Address');

export const CLIENT_ADDRESS_UPDATE_ID = createAction('[Client] Address Update Id', props<{ idAddress: string }>());

export const CLIENT_UPDATE_FORM = createAction('[Client] Update Form', props<{ clientAddressForm: Address | null }>());

export const CLIENT_UPDATE_ADDRESS = createAction('[Client] Update Address');

export const CLIENT_ADDRESS_CREATE_COMPLETED = createAction('[Client] Address Create Completed');
export const CLIENT_ADDRESS_UPDATE_COMPLETED = createAction('[Client] Address Update Completed');

export const CLIENT_FIND_LOCATION = createAction('[Client] Find Location');
export const CLIENT_FIND_LOCATION_SUCCESS = createAction('[Client] Find Location Success', props<{ location: ClientLocation }>());
export const CLIENT_FIND_LOCATION_FAILED = createAction('[Client] Find Location Failed', props<{ error: string }>());

export const CLIENT_ADDRESS_UPDATE_DEFAULT = createAction('[Client] Address Update Default', props<{ idAddress: string }>());

export const CLIENT_UPDATE_APARTMENT = createAction('[Client] Update Apartment', props<{ apartmentOrSuite: string }>());

export const CLIENT_UPDATE_DELIVERY_INSTRUCTIONS = createAction('[Client] Update Delivery Instructions',props<{ deliveryInstructions: string }>());

export const CLIENT_UPDATE = createAction('[Client] Update');

export const CLIENT_PERSONAL_INFORMATION_UPDATE_FORM = createAction('[Client] Personal Information update form',props<{ personalInformationForm: {
                                    firstName: string | null,
                                    lastName: string | null,
                                    email: string | null,
                                    phone: string | null,
                                  } }>());

export const CLIENT_CLEAR_STATE = createAction('[Client] Clear State');
